import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function CipherAdoption() {
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Cipher Adoption</CardTitle>
      </CardHeader>
      <CardContent className="flex items-center justify-center min-h-[150px]">
        <p className="text-muted-foreground text-sm text-center">
          Saves / retention analytics land alongside the subscription metering
          surface in Phase 06.
        </p>
      </CardContent>
    </Card>
  );
}
